import { Styles } from '@chakra-ui/theme-tools';

const styles: Styles = {
  global: {
    html: {
      height: '-webkit-fill-available',
    },
    body: {
      bg: 'gray.900',
      color: 'white',
    },
    '.dashboard-mini-calendar': {
      width: '100%',
      height: '100%',
      '.react-calendar__navigation': {
        pb: 3,
        borderBottomWidth: '2px',
        borderBottomColor: 'gray.900',
        justifyContent: 'center',
        '.react-calendar__navigation__label': {
          fontSize: '20px',
          fontWeight: 500,
          flexGrow: 'unset !important',
          _hover: {
            cursor: 'auto',
          },
        },
        '.react-calendar__navigation__arrow': {
          px: 4,
          fontSize: '20px',
        },
      },
      '.react-calendar__month-view__weekdays__weekday': {
        textAlign: 'center',
        fontWeight: 600,
        fontSize: '17px',
        px: 2,
        py: 4,
        abbr: {
          textDecoration: 'none',
        },
      },
      '.react-calendar__tile': {
        px: 2,
        py: 3,
        whiteSpace: 'nowrap',
        _hover: {
          cursor: 'auto',
        },
      },
      '.day-with-session': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        fontWeight: 600,
        _hover: {
          cursor: 'pointer',
        },
        '&:after': {
          content: '""',
          margin: '0 auto',
          position: 'absolute',
          display: 'block',
          width: '7px',
          bottom: '7px',
          height: '7px',
          borderRadius: '100%',
          bg: '#69b6d5',
        },
      },
    },
  },
};

export default styles;
